import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../../init-store';
import {
    isMessengerIntegration,
    selectIsGlobalBarEnabled,
    selectIsOnPremise,
    selectIsTeleMessenger,
} from '../config/selectors';
import { isPDDUserSelector, selectEnabledNoB2cTariffPromo } from '../user/selectors';

/**
 * @param {RootState} state
 * @returns {Object}
 */
export const getExperimentsFlags = ({ config: { experiments } }: RootState) => experiments?.flags;

export const getPremiumButtonEnabled = createSelector(
    [
        selectIsGlobalBarEnabled,
        isMessengerIntegration,
        selectEnabledNoB2cTariffPromo,
        isPDDUserSelector,
        selectIsOnPremise,
        selectIsTeleMessenger,
    ],
    (isGlobalBarEnabled, isMessengerIntegration, isEnabledNoB2cTariffPromo, isPDD, isOnPremise, isTeleMessenger) =>
        isGlobalBarEnabled &&
        !isMessengerIntegration &&
        !isEnabledNoB2cTariffPromo &&
        !isPDD &&
        !isOnPremise &&
        !isTeleMessenger
);
